<template>
  <section>
    <label>
      Place:
      <gmap-autocomplete
        id="place-name"
        @place_changed="SET_PLACE"
        @focus.native="$event.target.select()"
      ></gmap-autocomplete>
    </label>
    <label>
      Distance:
      <input v-model.number="$store.state.controls.dist" />
    </label>
    <label>
      Days back:
      <input v-model.number="$store.state.controls.back" />
    </label>
    <button @click="GET_CURRENT_LOCATION">
      Current Location
    </button>
    <button :disabled="!LOCATION" @click="FETCH_OBSERVATIONS">
      Fetch Observations
    </button>
    <span v-if="OBSERVATION_COUNT > 0"
      ><br />{{ OBSERVATION_COUNT }} observations
    </span>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";

export default {
  // TODO: consider v-model binding to this data, propating to service and/or
  // store on setting place or fetching observations
  data: () => {
    return {
      dist: 11,
      back: 22
    };
  },
  methods: {
    ...mapActions(["FETCH_OBSERVATIONS", "GET_CURRENT_LOCATION", "SET_PLACE"])
  },
  computed: {
    ...mapGetters(["LOCATION", "OBSERVATION_COUNT"])
  }
};
</script>

<style scoped>
section {
  padding: 8px;
}
#place-name {
  width: 25%;
}
input {
  width: 5%;
}
</style>
